import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics, Gtag } from '../../compornents/Analytics';
import React from 'react';

export const OrderStep5 = () => {
  const navigate = useNavigate();


  const next = () => {
    navigate('/home');
  }

  useEffect(() => {
    Gtag('view_order_step4');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="OrderStep5" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-5">{"STEP.5"}</div>
            <img src="/img/step4.png" alt="step5" className="App-img" />
            <div className="App-title">受け取る</div>
            <div className="App-comment">受け取り依頼をすることで<br/>すぐに依頼を受け取ることができます。</div>
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={6}
                  numPages={6}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"次へ"}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
